import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76206165"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "music" }
const _hoisted_2 = { id: "music-wrapper" }
const _hoisted_3 = {
  key: 0,
  "data-scroll": "",
  "data-scroll-sticky": "",
  "data-scroll-target": "#music-wrapper"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "black-box" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  "data-scroll": "",
  "data-scroll-speed": "-20",
  "data-scroll-direction": "horizontal"
}, "Music", -1))
const _hoisted_6 = { class: "videos-wrapper" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  "data-scroll": "",
  "data-scroll-speed": "-5",
  "data-scroll-direction": "horizontal"
}, "Music", -1))
const _hoisted_9 = {
  class: "videos-wrapper",
  "data-scroll": "",
  "data-scroll-sticky": "",
  "data-scroll-target": "#music-wrapper"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "black-bg" }, null, -1))

import { nextTick, onMounted, ref, onBeforeUnmount, computed } from 'vue';
  import YoutubeLayer from './YoutubeLayer.vue';
  import { Video } from '@/models/VideoModel';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MusicExamples',
  props: {
    videos: null
  },
  emits: ["rendered"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'rendered',): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    videos: Video[];
  };

  

  

  const videoWidth = ref(0);
  const videoHeight = computed(() => {
    return (videoWidth.value / 4) * 3;
  })
  const onResize = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 324) {
      videoWidth.value = screenWidth - 24;
    }
    else if (screenWidth < 500) {
      videoWidth.value = 300;
    }
    else if (screenWidth < 1000) {
      videoWidth.value = 350;
    }
    else {
      videoWidth.value = 480;
    }
  }
  onMounted(() => nextTick(() => {
    window.addEventListener('resize', onResize);
    onResize();
  }))
  onBeforeUnmount(() => window.removeEventListener('resize', onResize))

  onMounted(() => {
    nextTick(() => {
      window.addEventListener('load', () => {
        emit('rendered');
      })
    })
  })



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (videoWidth.value > 351)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("section", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.videos, (video, index) => {
                return (_openBlock(), _createBlock(YoutubeLayer, {
                  key: index,
                  class: "video",
                  "data-scroll": "",
                  "data-scroll-speed": index%2 === 0 ? 2 : -2,
                  "data-scroll-direction": videoWidth.value < 351 ? 'horizontal' : 'vertical',
                  videoId: video.id,
                  title: video.title,
                  width: videoWidth.value,
                  height: _unref(videoHeight),
                  radius: _unref(videoHeight) / 4
                }, null, 8, ["data-scroll-speed", "data-scroll-direction", "videoId", "title", "width", "height", "radius"]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("section", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.videos, (video, index) => {
                return (_openBlock(), _createBlock(YoutubeLayer, {
                  key: index,
                  class: "video",
                  "data-scroll": "",
                  "data-scroll-speed": index%2 === 0 ? 2 : -2,
                  "data-scroll-direction": videoWidth.value < 351 ? 'horizontal' : 'vertical',
                  videoId: video.id,
                  title: video.title,
                  width: videoWidth.value,
                  height: _unref(videoHeight),
                  radius: _unref(videoHeight) / 4
                }, null, 8, ["data-scroll-speed", "data-scroll-direction", "videoId", "title", "width", "height", "radius"]))
              }), 128))
            ])
          ])),
      _hoisted_10
    ])
  ]))
}
}

})